import './index.css';
import * as React from 'react';
import { connect } from '@wmfe/mach-pro-store';
import KNB from '@wmfe/mach-pro-knb';
import { View } from '@wmfe/mach-pro-components-react';
import { Dispatch, RootState } from '@/src/pages/homepage/quality_special_page_main/models/store';
import { EVENT_NAME } from '@/src/pages/channel_list/utils/constant';

const Statistics = Mach.requireModule('Statistics');
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const mapStateToProps = (state: RootState, dispatch: Dispatch) => ({

});

type BaseIProps = ReturnType<typeof mapStateToProps>;

interface Props extends BaseIProps {
  apiData?: any;
}

interface State {
  shareWidgetPvReported: boolean;
}

const cid = Mach.env?.schemeParams?.cid || '';
class HeaderTitleNavBar extends React.Component<Props, State> {
  navHeight = 0;
  constructor(props) {
    super(props);
    this.state = {
      shareWidgetPvReported: false
    };
  }
  scrollObserver: any = null;
  componentDidMount(): void {
    // 滚动监听
    this.scrollObserver = globalThis.eventBus.subscribe(EVENT_NAME.ONSCROLL, (offset) => {
      this.onScroll(offset);
    });
  }

  componentWillUnmount(): void {
    if (this.scrollObserver) {
      this.scrollObserver.unSubscribe?.();
      this.scrollObserver = null;
    }
  }

  navRef: any = null;
  navTitleRef: any = null;
  onScroll = (offset) => {
    if (!offset) {
      return;
    }

    // 设置导航栏组件位置（一直顶部锚定）
    if (this.navRef) {
      const { json_data } = this.props.apiData;
      const stickBgColor = json_data?.stickBgColor || '#ffffff';
      const unStickBgColor = json_data?.unStickBgColor || 'transparent';
      // 设置导航栏背景色
      if (offset.y > 100) {
        // 如滑动超过目标高度，则背景变为白色
        this.navRef.style.setProperty('background-color', stickBgColor);
        this.navTitleRef?.style?.setProperty?.('visibility', 'visible');
      } else {
        // 默认背景为透明
        this.navRef.style.setProperty('background-color', unStickBgColor);
        this.navTitleRef?.style?.setProperty?.('visibility', 'hidden');
      }
    }
  };

  /**
   * 关闭页面
   */
  closePage = () => {
    const WMRouter = Mach.requireModule('Router');
    WMRouter.navigateBack();
  };

  // eslint-disable-next-line react/no-unused-class-component-methods
  headerComponentItemAlwaysInSticky = () => true;

  handleOnShareClick() {
    const {
      shareImg, ...rest
    } = this.props.apiData?.json_data?.shareKits || {};
    Statistics.click(cid, 'b_sailor_c_x1xm3ujl_mc');
    const parsedShareImg = typeof shareImg === 'string' ? [shareImg] : shareImg;
    KNB.use('sailor.share', {
      ...rest,
      shareImg: parsedShareImg,
      biz_type_id: Mach?.env?.bundleName || 'channel_list_page', // 埋点使用
      extraData: {
        carryDataInfo: {
          activity_team_id: this.props.apiData?.json_data?.logData?.activity_team_id || -999,
          activity_id: this.props.apiData?.json_data?.logData?.activity_id || -9999
        }
      },
      success() {},
      // 用户取消了分享执行fail函数, -1-分享取消
      fail() {},
    });
  }

  handleShareWidgetOnView = (status: boolean) => {
    if (status && !this.state.shareWidgetPvReported) {
      Statistics.view(cid, 'b_sailor_c_x1xm3ujl_mv');
      this.setState({ shareWidgetPvReported: true });
    }
  };

  render() {
    const { json_data } = this.props.apiData;
    const {
      backImageUrl, title, shareKits, shareIcon
    } = json_data;
    const titleColor = json_data?.titleColor || '#222222';
    const unStickBgColor = json_data?.unStickBgColor || 'transparent';
    this.navHeight = Mach.env?.statusBarHeight + Mach.env?.navigationBarHeight;

    return (
      <view
        ref={(ref) => {
          this.navRef = ref;
        }}
        style={{
          width: '100%',
          height: this.navHeight,
          alignItems: 'flex-end',
          paddingBottom: 6,
          backgroundColor: unStickBgColor,
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between'
        }}
      >
        <view onClick={this.closePage}>
          <image
            className="back-icon"
            src={backImageUrl || 'assets://homepage/shopLandingPage/backRound.png'}
            autoRTL
          />
          <view
            ref={(ref: any) => {
              this.navTitleRef = ref;
            }}
            style={{ visibility: 'hidden' }}
          >
            <text content={title} className="nav-text" style={{ color: titleColor }} />
          </view>
        </view>

        {shareIcon && shareKits && (
          <View className="share-wrapper" onView={this.handleShareWidgetOnView}>
            <image
              className="share-icon"
              src={shareIcon}
              autoRTL
              onClick={this.handleOnShareClick.bind(this)}
            />
          </View>
        )}
      </view>
    );
  }
}

export default connect(mapStateToProps)(HeaderTitleNavBar);
